import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { set_token } from './util.js';
import { Navbar, Nav, Container, NavDropdown } from 'react-bootstrap';
import API from './api';

function Menu() {
  const navigate = useNavigate();
  const location = useLocation();
  const isDebug = process.env.NODE_ENV === 'development' || process.env.REACT_APP_DEBUG === 'true';
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    // Check if user is admin
    const checkAdminStatus = async () => {
      try {
        const response = await API.get('/api/users');
        // If we can list users, we're admin
        setIsAdmin(!response.error);
      } catch (err) {
        setIsAdmin(false);
      }
    };
    checkAdminStatus();
  }, []);

  const handleLogout = (e) => {
    e.preventDefault();
    set_token(undefined);
    navigate('/signin');
  };

  return (
    <Navbar bg="light" expand="lg" className="mb-4">
      <Container fluid className="px-4">
        <Navbar.Brand><strong>Feed</strong>filter</Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link
              as={Link}
              to="/sources"
              active={location.pathname === '/sources'}
            >
              Sources
            </Nav.Link>
            <Nav.Link
              as={Link}
              to="/filters"
              active={location.pathname === '/filters'}
            >
              Filters
            </Nav.Link>
            <Nav.Link
              as={Link}
              to="/endpoints"
              active={location.pathname === '/endpoints'}
            >
              Endpoints
            </Nav.Link>
            <Nav.Link
              as={Link}
              to="/server"
              active={location.pathname === '/server'}
            >
              Server
            </Nav.Link>
            {isDebug && (
              <Nav.Link
                as={Link}
                to="/test-feed"
                active={location.pathname === '/test-feed'}
              >
                Test Feed
              </Nav.Link>
            )}
          </Nav>
          <Nav className="ms-auto">
            <NavDropdown title="Account" id="account-dropdown" align="end">
              <NavDropdown.Item as={Link} to="/settings">
                Settings
              </NavDropdown.Item>
              {isAdmin && (
                <NavDropdown.Item as={Link} to="/users">
                  User Management
                </NavDropdown.Item>
              )}
              <NavDropdown.Divider />
              <NavDropdown.Item onClick={handleLogout}>
                Log out
              </NavDropdown.Item>
            </NavDropdown>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default Menu;
